import { render, staticRenderFns } from "./ConfiguracaoLimiteCotasFluxoComum.vue?vue&type=template&id=4bddf2da&scoped=true&"
import script from "./ConfiguracaoLimiteCotasFluxoComum.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoLimiteCotasFluxoComum.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracaoLimiteCotasFluxoComum.vue?vue&type=style&index=0&id=4bddf2da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bddf2da",
  null
  
)

export default component.exports